/* assets/littleg-generator-renderer.js — GCITYPARTNERS-PROJECT-PLAYBOOK-RUNTIME-05
 * Canonical runtime owner for /pages/generator.
 * Owns filters, URL template state, playbook selection, composer prefills, local preliminary drafts and reuse.
 * Boundary: no backend/API execution, GFun mutation, checkout or formal report claim.
 */
(function () {
  'use strict';

  var VERSION = '2026-07-26-gcitypartners-project-playbook-runtime-05';
  if (window.LittleGGeneratorRenderer && window.LittleGGeneratorRenderer.version === VERSION) return;

  var currentScriptSrc = (document.currentScript && document.currentScript.src) || '';
  var storagePromise = null;
  var FILTERS = [
    'all',
    'urban-renewal',
    'asset-revitalization',
    'surveying-spatial',
    'planning-approval',
    'low-altitude-inspection',
    'tender-opportunities'
  ];

  function lockCanonicalGeneratorRoute() {
    var path = String(window.location.pathname || '/')
      .replace(/\/{2,}/g, '/')
      .replace(/\/+$/, '') || '/';

    if (path.toLowerCase() !== '/pages/generator') return false;

    var targetUrl = new URL(
      '/pages/result-history?source=alias&intent=city-mission-cards',
      window.location.origin
    );
    var incomingParams = new URLSearchParams(window.location.search || '');

    incomingParams.forEach(function (value, key) {
      if (!targetUrl.searchParams.has(key)) targetUrl.searchParams.append(key, value);
    });

    if (!targetUrl.hash && window.location.hash) targetUrl.hash = window.location.hash;

    var currentUrl = path + window.location.search + window.location.hash;
    var target = targetUrl.pathname + targetUrl.search + targetUrl.hash;
    var marker =
      'gcity_alias_redirected:' +
      currentUrl.toLowerCase() +
      '→' +
      target.toLowerCase();

    try {
      window.sessionStorage.setItem(marker, '1');
    } catch (_) {}

    document.documentElement.dataset.generatorCanonicalRoute = 'true';
    return true;
  }

  lockCanonicalGeneratorRoute();

  function one(selector, root) {
    return (root || document).querySelector(selector);
  }

  function all(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  function clean(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isChinese(root) {
    return (
      clean(document.documentElement.lang).toLowerCase().indexOf('zh') === 0 ||
      clean(root && root.dataset.locale).toLowerCase().indexOf('zh') === 0
    );
  }

  function reducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function words(root) {
    return isChinese(root)
      ? {
          selected: '已選模板',
          selectRequired: '請先在模板廣場套用一個模板。',
          build: '建立初步簡報',
          required: '請先輸入這次項目需要解決的真實問題。',
          saving: '正在保存至此瀏覽器…',
          saved: '已保存至此瀏覽器（未同步其他裝置）。',
          ready: '保存失敗。草稿仍在本頁，請重試保存。',
          downloadFailed: '未能匯出此草稿，請確認本機記錄仍然存在。',
          downloadStarted: '已要求瀏覽器下載 JSON 草稿，請檢查下載項目。',
          stage: '適用階段',
          fit: '適用',
          output: '預計成果',
          question: '本次項目問題',
          gaps: '仍需補充',
          gapItems: [
            '項目位置或範圍',
            '現有資料與權屬狀態',
            '時間要求與決策目標'
          ],
          disclaimer:
            '此結果只屬本機初步項目草稿，不構成正式報告、投標文件、估值、測量、規劃或法律結論。',
          filterLabel: '模板分類',
          filters: [
            '全部',
            '城市更新',
            '資產盤活',
            '測繪空間',
            '規劃報批',
            '低空巡檢',
            '招標機會'
          ],
          reused: '已帶回原模板與項目問題，請更新資料後建立新草稿。'
        }
      : {
          selected: 'Selected playbook',
          selectRequired: 'Apply a playbook from the gallery first.',
          build: 'Build preliminary brief',
          required: 'Enter the real project question to resolve first.',
          saving: 'Saving to this browser…',
          saved: 'Saved in this browser (not synced to other devices).',
          ready: 'Save failed. This draft remains on this page; retry saving.',
          downloadFailed: 'Unable to export this draft. Check that its saved record is still available.',
          downloadStarted: 'JSON draft download requested. Check your browser downloads.',
          stage: 'Stage',
          fit: 'For',
          output: 'Expected output',
          question: 'Project question',
          gaps: 'Still required',
          gapItems: [
            'Project location or scope',
            'Available data and rights status',
            'Timeline and decision objective'
          ],
          disclaimer:
            'This is a local preliminary project draft. It is not a formal report, bid submission, valuation, survey, planning or legal conclusion.',
          filterLabel: 'Playbook categories',
          filters: [
            'All',
            'Urban renewal',
            'Asset activation',
            'Surveying & spatial',
            'Planning approval',
            'Low-altitude inspection',
            'Tender opportunities'
          ],
          reused:
            'The playbook and project question are ready. Update the details before creating a new draft.'
        };
  }

  function cardData(card) {
    return {
      handle: clean(card.dataset.generatorHandle),
      market: clean(card.dataset.marketHandle),
      category: clean(card.dataset.playbookCategory),
      title: clean(card.dataset.playbookTitle),
      stage: clean(card.dataset.playbookStage),
      fit: clean(card.dataset.playbookFit),
      output: clean(card.dataset.playbookOutput),
      prompt: clean(card.dataset.playbookPrompt),
      route: clean(card.dataset.playbookRoute).replace(
        '#review-brief',
        '#gcp-brief-form'
      )
    };
  }

  function storageUrl() {
    return currentScriptSrc
      ? currentScriptSrc
          .replace(/[?#].*$/, '')
          .replace(/[^/]+$/, 'littleg-city-result-storage.js')
      : '/assets/littleg-city-result-storage.js';
  }

  function storageOwner() {
    if (
      window.LittleGResultStorage &&
      typeof window.LittleGResultStorage.saveResult === 'function'
    ) {
      return Promise.resolve(window.LittleGResultStorage);
    }

    if (storagePromise) return storagePromise;

    storagePromise = new Promise(function (resolve, reject) {
      var script =
        document.querySelector(
          'script[data-littleg-result-storage-loader="true"]'
        ) || document.createElement('script');

      if (!script.src) {
        script.src = storageUrl();
        script.defer = true;
        script.dataset.littlegResultStorageLoader = 'true';
        document.head.appendChild(script);
      }

      script.addEventListener(
        'load',
        function () {
          resolve(window.LittleGResultStorage || null);
        },
        { once: true }
      );
      script.addEventListener('error', reject, { once: true });
    });

    return storagePromise;
  }

  function save(result) {
    return storageOwner()
      .then(function (owner) {
        var stored =
          owner && owner.saveResult
            ? owner.saveResult(result, 'generator')
            : null;

        window.dispatchEvent(
          new CustomEvent('littleg:generator-preview:save-requested', {
            detail: {
              result: result,
              saved: !!stored,
              saved_result: stored || null,
              source: 'gcitypartners-project-playbook'
            }
          })
        );

        return stored || null;
      })
      .catch(function () {
        return null;
      });
  }

  function toast(message, error) {
    if (window.showGcityFeedback) {
      return window.showGcityFeedback(message, error ? 'error' : 'success');
    }

    var root = document.getElementById('ggen-toast-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'ggen-toast-root';
      document.body.appendChild(root);
    }

    var node = document.createElement('div');
    node.className = 'ggen-toast' + (error ? ' ggen-toast--error' : '');
    node.textContent = message;
    root.appendChild(node);

    window.setTimeout(function () {
      node.remove();
    }, 2800);
  }

  function compose(shell, text) {
    shell.dataset.visualOwner = 'assets/littleg-generator.css';
    shell.dataset.runtimeOwner = 'assets/littleg-generator-renderer.js';

    var workbench = one('.ggen-workbench', shell);
    if (!workbench) {
      workbench = document.createElement('section');
      workbench.className = 'ggen-workbench';
      workbench.dataset.ggenWorkbench = 'true';

      var heading = one('[data-role="generator-heading"]', shell);
      workbench.setAttribute(
        'aria-label',
        clean(heading && heading.textContent) || text.filterLabel
      );

      shell.insertBefore(workbench, shell.firstChild);

      Array.prototype.slice.call(shell.children).forEach(function (child) {
        if (child !== workbench && child.tagName !== 'SCRIPT') {
          workbench.appendChild(child);
        }
      });
    }

    return workbench;
  }

  function filters(root, text) {
    var grid = one('[data-littleg-generator-grid]', root);
    var nav = one('[data-playbook-filters]', root);

    if (!grid || nav) return nav;

    nav = document.createElement('nav');
    nav.className = 'ggen-playbook-filters';
    nav.dataset.playbookFilters = 'true';
    nav.setAttribute('aria-label', text.filterLabel);

    FILTERS.forEach(function (key, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ggen-playbook-filter';
      button.dataset.playbookFilter = key;
      button.textContent = text.filters[index];
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      nav.appendChild(button);
    });

    grid.parentNode.insertBefore(nav, grid);
    return nav;
  }

  function setText(root, selector, value) {
    var node = one(selector, root);
    if (node) node.textContent = value;
    return node;
  }

  function setSaveStatus(output, status, message) {
    if (!output) return;
    output.dataset.saveState = status;
    var node = one('[data-output-save-status]', output);
    if (node) {
      node.dataset.saveState = status;
      node.textContent = message;
    }
    ['[data-output-spatial]', '[data-output-history]', '[data-output-download]'].forEach(function (selector) {
      var action = one(selector, output);
      if (action) action.hidden = status !== 'saved';
    });
    var retry = one('[data-output-save-retry]', output);
    if (retry) retry.hidden = status !== 'error';
  }

  function requestedResumeId() {
    try {
      var url = new URL(window.location.href);
      return url.searchParams.get('intent') === 'resume-playbook'
        ? clean(url.searchParams.get('record_id')).slice(0, 120) : '';
    } catch (_) { return ''; }
  }

  function requestedTemplate() {
    try {
      return clean(new URL(window.location.href).searchParams.get('template'));
    } catch (_) {
      return '';
    }
  }

  function updateTemplateUrl(handle) {
    if (!handle || !window.history || !window.history.pushState) return;

    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('template') === handle) return;
      url.searchParams.set('template', handle);
      window.history.pushState(
        window.history.state,
        '',
        url.pathname + url.search + url.hash
      );
    } catch (_) {}
  }

  function scrollToComposer(composer, input) {
    if (!composer) return;

    composer.scrollIntoView({
      behavior: reducedMotion() ? 'auto' : 'smooth',
      block: 'center'
    });

    window.requestAnimationFrame(function () {
      if (input) input.focus({ preventScroll: true });
    });
  }

  function render(root, data, query, text, sourceRecordId) {
    var output = one('[data-littleg-generator-output]', root);
    if (!output || !data) return null;

    var id =
      'gcp-playbook-' +
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2, 8);

    var result = {
      id: id,
      result_id: id,
      record_id: id,
      card_id: id,
      source_record_id: sourceRecordId || null,
      lead_type: 'professional_project_playbook',
      source: 'gcitypartners-project-playbook',
      generator_handle: data.handle,
      generator_name: data.title,
      market_handle: data.market,
      market_name: data.category,
      playbook_category: data.category,
      playbook_stage: data.stage,
      playbook_fit: data.fit,
      playbook_output: data.output,
      query: query,
      formal_submission_status: 'not_submitted',
      visibility: 'private',
      status: 'local_preview_ready',
      created_at: new Date().toISOString(),
      routes: {
        result_history: '/pages/result-history?source=project-playbook&intent=saved-record&record_id=' + encodeURIComponent(id),
        download: null,
        spatial_continuation: data.route
      }
    };

    output.hidden = false;
    output.dataset.resultId = id;
    setSaveStatus(output, 'pending', text.saving);
    setText(output, '[data-output-title]', data.title);
    setText(
      output,
      '[data-output-summary]',
      data.stage + ' · ' + data.output
    );

    var body = one('[data-output-body]', output);
    if (!body) return null;

    body.replaceChildren();

    var facts = document.createElement('dl');
    facts.className = 'lg-gen-output__facts';

    [
      [text.stage, data.stage],
      [text.fit, data.fit],
      [text.output, data.output],
      [text.question, query]
    ].forEach(function (pair) {
      var box = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = pair[0];
      dd.textContent = pair[1];
      box.append(dt, dd);
      facts.appendChild(box);
    });

    var gaps = document.createElement('div');
    gaps.className = 'lg-gen-output__gaps';

    var strong = document.createElement('strong');
    strong.textContent = text.gaps;

    var list = document.createElement('ul');
    text.gapItems.forEach(function (item) {
      var li = document.createElement('li');
      li.textContent = item;
      list.appendChild(li);
    });

    gaps.append(strong, list);
    body.append(facts, gaps);

    var spatial = one('[data-output-spatial]', output);
    var history = one('[data-output-history]', output);
    if (spatial) spatial.href = data.route;
    if (history) history.href = result.routes.result_history;

    setText(output, '[data-output-disclaimer]', text.disclaimer);

    window.dispatchEvent(
      new CustomEvent('littleg:preview-generated', { detail: result })
    );

    // Bring the completed brief into view and move focus away from the keyboard.
    output.focus();
    return result;
  }

  function boot(root) {
    if (!root || root.dataset.littlegGeneratorPreviewBooted === VERSION) return;

    root.dataset.littlegGeneratorPreviewBooted = VERSION;

    var shell = root.closest('.ggen-shell');
    var text = words(root);
    var cards = all('[data-littleg-generator-card]', root);
    var input = one('[data-generator-query]', root);
    var run = one('[data-generator-preview-run]', root);
    var label = one('[data-generator-selected-label]', root);
    var composer = one('[data-generator-composer]', root);
    var output = one('[data-littleg-generator-output]', root);

    if (!shell || !cards.length || !input || !run || !composer) {
      root.dataset.generatorMatrixReady = 'false';
      return;
    }

    root.dataset.generatorMatrixReady = 'true';
    compose(shell, text);

    var nav = filters(root, text);
    var state = {
      card: null,
      data: null,
      lastResult: null,
      reuseSourceId: null,
      drafts: Object.create(null)
    };
    var emptyLabel = label ? label.textContent : '';
    var emptyPlaceholder = input.placeholder;

    function select(card, options) {
      if (!card || card.hidden) return;

      options = options || {};
      var previousHandle = state.data ? state.data.handle : '';
      var nextHandle = clean(card.dataset.generatorHandle);
      if (previousHandle !== nextHandle) {
        state.drafts[previousHandle] = input.value;
      }
      state.card = card;
      state.data = cardData(card);

      cards.forEach(function (candidate) {
        var active = candidate === card;
        candidate.classList.toggle('is-active', active);

        var button = one('[data-generator-select]', candidate);
        if (button) {
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        }
      });

      if (label) {
        label.textContent =
          text.selected +
          '：' +
          state.data.title +
          ' · ' +
          state.data.output;
      }

      var previousPrefill = clean(input.dataset.templatePrefill);
      var currentValue = clean(input.value);

      if (options.prefill !== false) {
        if (previousHandle !== state.data.handle &&
            Object.prototype.hasOwnProperty.call(state.drafts, state.data.handle)) {
          input.value = state.drafts[state.data.handle];
        } else if (previousHandle !== state.data.handle) {
          // Keep a question typed before the first template is applied.
          if (previousHandle || !currentValue) input.value = state.data.prompt;
        } else if (!currentValue || currentValue === previousPrefill) {
          input.value = state.data.prompt;
        }
      }

      input.dataset.templatePrefill = state.data.prompt;
      input.placeholder = state.data.prompt;
      run.textContent = text.build;
      if (output && previousHandle !== state.data.handle) output.hidden = true;

      if (options.updateUrl !== false) {
        updateTemplateUrl(state.data.handle);
      }

      window.dispatchEvent(
        new CustomEvent('littleg:generator:selected', {
          detail: state.data
        })
      );

      if (options.focusComposer) {
        scrollToComposer(composer, input);
      }
    }

    function clearSelection() {
      if (state.data) state.drafts[state.data.handle] = input.value;
      state.card = null;
      state.data = null;
      cards.forEach(function (card) {
        card.classList.remove('is-active');
        var button = one('[data-generator-select]', card);
        if (button) button.setAttribute('aria-pressed', 'false');
      });
      if (label) label.textContent = emptyLabel;
      input.value = Object.prototype.hasOwnProperty.call(state.drafts, '')
        ? state.drafts[''] : '';
      input.dataset.templatePrefill = '';
      input.placeholder = emptyPlaceholder;
      if (output) output.hidden = true;
    }

    function apply(key) {
      cards.forEach(function (card) {
        card.hidden =
          key !== 'all' && card.dataset.playbookCategory !== key;
      });

      all('[data-playbook-filter]', nav || root).forEach(function (button) {
        button.setAttribute(
          'aria-pressed',
          button.dataset.playbookFilter === key ? 'true' : 'false'
        );
      });

      // Filtering only changes visible choices; it must not apply a template.
    }

    cards.forEach(function (card) {
      var button = one('[data-generator-select]', card);
      if (!button) return;

      button.addEventListener('click', function () {
        select(card, { focusComposer: true, updateUrl: true });
      });
    });

    all('[data-playbook-filter]', nav || root).forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.dataset.playbookFilter || 'all');
      });
    });

    function restoreHistorySelection() {
      // Retired Shopify theme-editor sections must not react to navigation.
      if (!root.isConnected) {
        window.removeEventListener('popstate', restoreHistorySelection);
        return;
      }

      var handle = requestedTemplate();
      var card = cards.filter(function (candidate) {
        return clean(candidate.dataset.generatorHandle) === handle;
      })[0];

      if (!card) {
        clearSelection();
        return;
      }
      if (card.hidden) apply('all');
      select(card, { focusComposer: false, updateUrl: false });
    }

    window.addEventListener('popstate', restoreHistorySelection);

    all('[data-generator-suggestion]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var suggestion = clean(button.dataset.generatorSuggestion);
        var current = clean(input.value);
        var separator = isChinese(root) ? '；' : '; ';

        input.value = current ? current + separator + suggestion : suggestion;
        input.dataset.templatePrefill = '';
        input.focus();
      });
    });

    function saveCurrentResult(result) {
      if (!output || !result) return;
      setSaveStatus(output, 'pending', text.saving);
      save(result).then(function (stored) {
        if (output.hidden || output.dataset.resultId !== result.id) return;
        setSaveStatus(output, stored ? 'saved' : 'error', stored ? text.saved : text.ready);
        toast(stored ? text.saved : text.ready, !stored);
      });
    }

    var downloadDraft = one('[data-output-download]', output || root);
    if (downloadDraft) {
      downloadDraft.addEventListener('click', function () {
        if (!state.lastResult || !output || output.hidden ||
            output.dataset.saveState !== 'saved' ||
            output.dataset.resultId !== state.lastResult.id) return;

        var result = state.lastResult;
        var fileUrl = null;
        try {
          var owner = window.LittleGResultStorage;
          var exported = owner && typeof owner.exportResultJson === 'function'
            ? owner.exportResultJson(result.id) : null;
          var entry = exported && exported.result;
          if (!entry || clean(entry.record_id || entry.result_id) !== result.id ||
              clean(entry.storage_path) !== 'generator' ||
              clean(entry.source) !== 'gcitypartners-project-playbook' ||
              clean(entry.lead_type) !== 'professional_project_playbook' ||
              clean(entry.query) !== clean(result.query) ||
              typeof URL.createObjectURL !== 'function') {
            throw new Error('playbook_export_unavailable');
          }

          var blob = new Blob([JSON.stringify(exported, null, 2) + '\n'], {
            type: 'application/json;charset=utf-8'
          });
          fileUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          var handle = clean(result.generator_handle).replace(/[^a-z0-9_-]/gi, '-').slice(0, 48);
          var id = clean(result.id).replace(/[^a-z0-9_-]/gi, '-').slice(0, 80);
          link.href = fileUrl;
          link.download = 'littleg-playbook-' + handle + '-' + id + '.json';
          link.hidden = true;
          document.body.appendChild(link);
          try {
            link.click();
          } finally {
            link.remove();
          }
          var revokeUrl = fileUrl;
          window.setTimeout(function () {
            URL.revokeObjectURL(revokeUrl);
          }, 60000);
          fileUrl = null;
          toast(text.downloadStarted, false);
        } catch (_) {
          if (fileUrl && typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(fileUrl);
          toast(text.downloadFailed, true);
        }
      });
    }

    var retrySave = one('[data-output-save-retry]', output || root);
    if (retrySave) {
      retrySave.addEventListener('click', function () {
        if (!state.lastResult || !output || output.hidden ||
            output.dataset.resultId !== state.lastResult.id ||
            output.dataset.saveState !== 'error') return;
        saveCurrentResult(state.lastResult);
      });
    }

    run.addEventListener('click', function () {
      if (!state.data) {
        toast(text.selectRequired, true);
        var firstAvailable = cards.filter(function (card) {
          return !card.hidden;
        })[0];
        var firstAction = firstAvailable && one('[data-generator-select]', firstAvailable);
        if (firstAction) firstAction.focus();
        return;
      }

      var query = clean(input.value);

      if (!query) {
        toast(text.required, true);
        input.focus();
        return;
      }

      var result = render(
        root,
        state.data,
        query,
        text,
        state.reuseSourceId
      );

      if (!result) return;

      state.lastResult = result;
      state.reuseSourceId = null;

      saveCurrentResult(result);
    });

    input.addEventListener('keydown', function (event) {
      if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
        event.preventDefault();
        run.click();
      }
    });

    var reuse = one('[data-output-reuse]', output || root);
    if (reuse) {
      reuse.addEventListener('click', function () {
        if (!state.lastResult) return;

        state.reuseSourceId = state.lastResult.id;

        var reusableCard = cards.filter(function (card) {
          return (
            clean(card.dataset.generatorHandle) ===
            state.lastResult.generator_handle
          );
        })[0];

        if (reusableCard) {
          select(reusableCard, {
            focusComposer: false,
            updateUrl: true,
            prefill: false
          });
        }

        input.value =
          clean(state.lastResult.query) ||
          (state.data && state.data.prompt) ||
          '';
        input.dataset.templatePrefill = '';

        if (output) output.hidden = true;

        toast(text.reused, false);
        scrollToComposer(composer, input);

        window.dispatchEvent(
          new CustomEvent('littleg:generator:reuse-requested', {
            detail: {
              source_record_id: state.lastResult.id,
              generator_handle: state.lastResult.generator_handle
            }
          })
        );
      });
    }

    var templateHandle = requestedTemplate();
    var initialCard = cards.filter(function (card) {
      return clean(card.dataset.generatorHandle) === templateHandle;
    })[0];

    if (initialCard) {
      select(initialCard, {
        focusComposer: false,
        updateUrl: false,
        prefill: true
      });
    }

    apply('all');

    var resumeId = requestedResumeId();
    if (resumeId && initialCard) {
      storageOwner().then(function (owner) {
        var record = owner && owner.getResult ? owner.getResult(resumeId) : null;
        if (!record || !root.isConnected ||
            clean(record.record_id) !== resumeId ||
            clean(record.storage_path) !== 'generator' ||
            clean(record.lead_type) !== 'professional_project_playbook' ||
            clean(record.source) !== 'gcitypartners-project-playbook' ||
            clean(record.generator_handle) !== templateHandle ||
            !clean(record.query) || !state.data ||
            state.data.handle !== templateHandle ||
            clean(input.value) !== clean(state.data.prompt)) return;
        input.value = clean(record.query);
        state.reuseSourceId = resumeId;
        toast(text.reused, false);
      }).catch(function () {});
    }

    window.dispatchEvent(
      new CustomEvent('littleg:generator-preview:ready', {
        detail: {
          count: cards.length,
          source: 'gcitypartners-project-playbook',
          primary_entry: '/pages/generator',
          selected_template:
            state.data && state.data.handle ? state.data.handle : ''
        }
      })
    );
  }

  function bootAll() {
    all('[data-littleg-free-preview-root]').forEach(boot);
  }

  window.LittleGGeneratorRenderer = {
    version: VERSION,
    bootAll: bootAll,
    requestStorageSave: save,
    loadStorageOwner: storageOwner,
    lockCanonicalGeneratorRoute: lockCanonicalGeneratorRoute
  };

  document.addEventListener('DOMContentLoaded', bootAll);
  document.addEventListener('shopify:section:load', bootAll);

  if (document.readyState !== 'loading') bootAll();
})();
